<template>
  <b-modal ref="fuel-tank-card-modal" @ok="fuelTankCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.fuelTanks.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.name"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="name"
          :state="isNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.volume"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          v-model="volume"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.height"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="100000000000"
          v-model="height"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.density"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="fuelDensity"
          type="number"
          min="0"
          max="1"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.shape"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="shape"
          :options="shapeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.serialNumberOfLevelGauge"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="serialNumberOfLevelGauge"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.isActive"
        label-for="input-horizontal"
      >
        <b-form-checkbox
            v-model="isActive"
            :value="1"
            :unchecked-value="0"
          >
          </b-form-checkbox>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.startDate"
        label-for="input-horizontal"
      >
       <b-form-datepicker
          v-model="startDate"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.lastCheckDate"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="lastCheckDate"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.tanksId"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="tanksId"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.vehicleId"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="9999999999"
          v-model="vehicleId"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.sensorId"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="65535"
          v-model="sensorId"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="fuelTank.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateFuelTankPage",
  props: {
    fuelTank: Object,
    users: Array,
  },
  components: {},
  data() {
    return {
      name: null,
      volume: null,
      height: null,
      fuelDensity: null,
      shape: null,
      serialNumberOfLevelGauge: null,
      isActive: null,
      vehicleId: null,
      sensorId: null,

      isNameValid: null,
      created: null,
      updated: null,
      startDate: null,
      lastCheckDate: null,
      tanksId: null
    };
  },
  computed: {
    shapeOptions() {
      const shapeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.azk.fuelTanks.shapeOptions
          .length;
        i++
      ) {
        shapeOptions.push({
          value:
            this.$store.state.localization.data.mainPage.azk.fuelTanks
              .shapeOptions[i].key,
          text: this.$store.state.localization.data.mainPage.azk.fuelTanks
            .shapeOptions[i].value,
        });
      }
      return shapeOptions;
    },
    calendarLocale() {
      return utilsService.getCalendarLocale(this.$store.state.localization.locale);
    },
  },
  methods: {
    async open() {
      this.name = this.fuelTank.name;
      this.volume = this.fuelTank.volume;
      this.height = this.fuelTank.height;
      this.fuelDensity = this.fuelTank.fuelDensity;
      this.shape = this.fuelTank.shape;
      this.serialNumberOfLevelGauge = this.fuelTank.serialNumberOfLevelGauge;
      this.isActive = this.fuelTank.isActive;
      this.vehicleId = this.fuelTank.vehicleId;
      this.sensorId = this.fuelTank.sensorId;

      this.created = utilsService.formatDateTime(new Date(this.fuelTank.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.fuelTank.updated * 1000), utilsService.DATE_TIME_FORMAT);

      if (this.fuelTank.startDate) {
        this.startDate = utilsService.convertUnixTimeToDate(this.fuelTank.startDate);
      } 

      if (this.fuelTank.lastCheckDate) {
        this.lastCheckDate = utilsService.convertUnixTimeToDate(this.fuelTank.lastCheckDate);
      } 

      if (this.fuelTank.tanksId) {
        this.tanksId = this.fuelTank.tanksId.join(",");
      } 

      this.$refs["fuel-tank-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.name) {
        this.isNameValid = false;
        isValid = false;
      } else {
        this.isNameValid = null;
      }

      return isValid;
    },
    async fuelTankCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      if (this.startDate) {
        this.fuelTank.startDate = this.startDate.getTime() / 1000;
      }

      if (this.lastCheckDate) {
        this.fuelTank.lastCheckDate = this.lastCheckDate.getTime() / 1000;
      }

      if (this.tanksId) {
        this.fuelTank.tanksId = this.tanksId.split(",");
      } else {
        this.fuelTank.tanksId = [];
      }

      this.fuelTank.name = this.name;
      this.fuelTank.volume = this.volume;
      this.fuelTank.height = this.height;
      this.fuelTank.fuelDensity = this.fuelDensity;
      this.fuelTank.shape = this.shape;
      this.fuelTank.serialNumberOfLevelGauge = this.serialNumberOfLevelGauge;
      this.fuelTank.isActive = this.isActive;
      this.fuelTank.vehicleId = this.vehicleId;
      this.fuelTank.sensorId = this.sensorId;

      const updateFuelTankResponse = await azkService.updateFuelTank(this.fuelTank);

      if (
        updateFuelTankResponse.isSuccess &&
        updateFuelTankResponse.data &&
        updateFuelTankResponse.data.countInsertedRows == 1
      ) {
        this.$emit("fuelTankUpdatedSuccessEvent");
      } else {
        this.$emit("fuelTankUpdatedFailEvent");
      }
    },
  },
};
</script>
